export default __webpack_public_path__ + "static/media/arrow-fat-down-white.4add1697.svg";